import { z } from 'zod';
import { userRoleSchema } from '../../common/schemas/enum.schemas.js';
import { uuidSchema } from '../../common/schemas/id.schemas.js';
export const MIN_PASSWORD_LENGTH = 8;
/**
 * The trimmed user shape that travels with every token pair and `auth.me` response. It carries the
 * tenant and the membership role, because a session is always "this user, inside this tenant, with this
 * role" (plan §2.3) — never a user on its own.
 */
export const userSummarySchema = z.object({
    id: uuidSchema,
    email: z.string().email(),
    name: z.string().min(1),
    tenantId: uuidSchema,
    tenantName: z.string().min(1),
    /**
     * The workspace's IANA zone. It travels with the session because "today" is a **business** day: the
     * estimator computes the default valuation date and the quick range against the dealership's
     * calendar, not the browser's (plan §11 fix 13).
     */
    tenantTimezone: z.string().min(1),
    role: userRoleSchema,
    /** Set by an admin password reset; the web app forces `/change-password` until it clears. */
    mustChangePassword: z.boolean(),
});
export const loginInputSchema = z.object({
    email: z.string().min(1, 'Email is required').email('Enter a valid email address'),
    password: z.string().min(1, 'Password is required'),
});
export const refreshInputSchema = z.object({
    refreshToken: z.string().min(1, 'Refresh token is required'),
});
export const tokensOutputSchema = z.object({
    accessToken: z.string().min(1),
    refreshToken: z.string().min(1),
    user: userSummarySchema,
});
export const changePasswordInputSchema = z.object({
    currentPassword: z.string().min(1, 'Enter your current password'),
    newPassword: z.string().min(MIN_PASSWORD_LENGTH, `Use at least ${MIN_PASSWORD_LENGTH} characters`),
});
//# sourceMappingURL=auth.schemas.js.map